<template>
  <NavbarSection />
  <router-view />
  <FooterSection />
</template>

<script>
import FooterSection from '@/components/FooterSection.vue';
import NavbarSection from '@/components/NavbarSection.vue';

export default {
  name: 'App',
  components: {
    FooterSection,
    NavbarSection,
  },
};
</script>

<style lang="scss">
$darkblue: #003366;
$blue: #335C85;
$lightblue: #99ADC2;
$otherblue: #6685A3;
$bgwhite: #E6E6E6;

@font-face {
  font-family: 'Nico Moji';
  src: url('@/assets/Nico-Moji/nicomoji/NicoMoji-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: $bgwhite;
}
body {
  margin: 0px;
  background-color: $bgwhite;
}
</style>
